import type { LoomProvisionalUnionSurface } from "./loomProvisionalUnionPreview";
import type { LoomProvisionalUnionRuntime } from "./loomProvisionalUnionScheduler";

export function loomProvisionalUnionDataAttributes(
  surface: LoomProvisionalUnionSurface | null,
  runtime: LoomProvisionalUnionRuntime,
): Record<string, string | number> {
  return {
    "data-provisional-union-adaptive-candidate-triangle-count": surface?.adaptiveCandidateTriangleCount ?? 0,
    "data-provisional-union-adaptive-generated-patch-triangle-count": surface?.adaptiveGeneratedPatchTriangleCount ?? 0,
    "data-provisional-union-adaptive-safety-probe-count": surface?.adaptiveSafetyProbeCount ?? 0,
    "data-provisional-union-adaptive-subdivided-triangle-count": surface?.adaptiveSubdividedTriangleCount ?? 0,
    "data-provisional-union-boundary-edges": surface?.boundaryEdgeCount ?? "none",
    "data-provisional-union-build-ms": surface?.buildMs.toFixed(2) ?? "none",
    "data-provisional-union-cache-compatibility-receipt-hit-count": surface?.cacheCompatibilityReceiptHitCount ?? 0,
    "data-provisional-union-cache-compatibility-receipt-miss-count": surface?.cacheCompatibilityReceiptMissCount ?? 0,
    "data-provisional-union-cache-compiled-field-hit-count": surface?.cacheCompiledFieldHitCount ?? 0,
    "data-provisional-union-cache-compiled-field-miss-count": surface?.cacheCompiledFieldMissCount ?? 0,
    "data-provisional-union-cache-explicit-surface-hit-count": surface?.cacheExplicitSurfaceHitCount ?? 0,
    "data-provisional-union-cache-explicit-surface-miss-count": surface?.cacheExplicitSurfaceMissCount ?? 0,
    "data-provisional-union-cache-operand-count": surface?.cacheOperandCount ?? 0,
    "data-provisional-union-cache-reused-operand-count": surface?.cacheReusedOperandCount ?? 0,
    "data-provisional-union-cache-revision": surface?.cacheRevision ?? "none",
    "data-provisional-union-classification": surface?.classificationStrategy ?? "none",
    "data-provisional-union-classification-evaluation-count": surface?.classificationEvaluationCount ?? 0,
    "data-provisional-union-classification-ms": surface?.classificationMs.toFixed(2) ?? "none",
    "data-provisional-union-classification-sample-cache-hit-count": surface?.classificationSampleCacheHitCount ?? 0,
    "data-provisional-union-classification-sample-count": surface?.classificationSampleCount ?? 0,
    "data-provisional-union-compatibility-evaluation-count": surface?.compatibilityEvaluationCount ?? 0,
    "data-provisional-union-compatibility-ms": surface?.compatibilityMs.toFixed(2) ?? "none",
    "data-provisional-union-compatibility-sample-count": surface?.compatibilitySampleCount ?? 0,
    "data-provisional-union-face-count": surface ? surface.faces.length / 3 : 0,
    "data-provisional-union-method": surface?.method ?? "none",
    "data-provisional-union-nonmanifold-edges": surface?.nonManifoldEdgeCount ?? "none",
    "data-provisional-union-prepare-ms": surface?.prepareMs.toFixed(2) ?? "none",
    "data-provisional-union-rejected-face-count": surface?.orientationRejectedFaceCount ?? "none",
    "data-provisional-union-rendered-request-id": runtime.renderedRequestId ?? "none",
    "data-provisional-union-rendered-revision": runtime.renderedRevision ?? "none",
    "data-provisional-union-request-id": runtime.requestId,
    "data-provisional-union-requested-revision": runtime.requestedRevision ?? "none",
    "data-provisional-union-reoriented-face-count": surface?.orientationRepairedFaceCount ?? "none",
    "data-provisional-union-source-operands": surface?.sourceOperandIds.length ?? 0,
    "data-provisional-union-source-residual-m": surface?.maxSourceSurfaceFieldResidualM ?? "none",
    "data-provisional-union-state": surface ? "available" : "unavailable",
    "data-provisional-union-topology-ms": surface?.topologyMs.toFixed(2) ?? "none",
    "data-provisional-union-trim-residual-m": surface?.maxTrimFieldResidualM ?? "none",
    "data-provisional-union-updating": String(runtime.updating),
    "data-provisional-union-worker-state": runtime.workerState,
  };
}
